import React from 'react'
import { Row, Col } from 'react-bootstrap'
import Button from './button'
import UserFullName from '../../user/full-name'
import DateConversational from '../../date/conversational'
import { PersonFill, Calendar3 } from 'react-bootstrap-icons'
import useMessageDeletion from '../../../hooks/use-message-deletion'
import useClientLocation from '../../../hooks/use-client-location'

const InboxMessage = ({
    message,
}) => {
    const { deleteMessage } = useMessageDeletion({ messageId: message.id})
    const { toMessageUser } = useClientLocation()

    return (
        <Col xl={12} style={{ paddingTop: '20px'}}>
            <div style={{
                boxShadow: '0px 0px 20px 10px rgb(238, 247, 255)',
                padding: '20px'
            }}>
                <Row style={{ paddingBottom: '10px'}}>
                    <Col>
                        <Row><Col style={{ fontSize: '20px', textOverflow: 'ellipsis' }}><strong>{message.subject}</strong></Col></Row>
                        <Row>
                            <Col>
                                <div style={{ display: 'flex', alignItems: 'center'}}>
                                    <PersonFill size={20} />
                                    <UserFullName user={message.author} style={{paddingLeft: '10px'}} />
                                </div>
                            </Col>
                            <Col>
                                <div style={{ display: 'flex', alignItems: 'center'}}>
                                    <Calendar3 size={20} />
                                    <DateConversational date={message.createdDate} style={{paddingLeft: '10px'}} dayName />
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={4}>
                        <Button variant='outline-secondary' onClick={deleteMessage}>DELETE</Button>
                        <Button onClick={() => toMessageUser(message.authorId, `re: ${message.subject}`)}>REPLY</Button>
                    </Col>
                </Row>
                <Row>
                    <Col><p style={{ color: 'black' }}>{message.content}</p></Col>
                </Row>
            </div>
        </Col>
    )
}

export default InboxMessage
